import dynamic from "next/dynamic";

import { useMode } from "../hooks/use-mode";
import { useThemeClass } from "../hooks/use-theme-class";
import type { LookbookProps } from "../lookbook";

const FeedView = dynamic<LookbookViewRouterProps>(async () =>
  import("./FeedView").then((module) => module.FeedView),
);
const StoryView = dynamic<LookbookViewRouterProps>(async () =>
  import("./StoryView").then((module) => module.StoryView),
);

export interface LookbookViewRouterProps extends LookbookProps {
  playing: boolean;
  setPlaying: (playing: boolean) => void;
}

export function LookbookViewRouter(props: LookbookViewRouterProps) {
  const mode = useMode();

  useThemeClass(mode, props.view);

  if (!mode) {
    return null;
  }

  if (props.view[mode] === "feed") {
    return <FeedView {...props} />;
  } else {
    return <StoryView {...props} />;
  }
}
